import client from "./client";

export const getJobs = ({ limit } = {}) => client.get(`/jobs${limit ? `?limit=${limit}` : ""}`);

export const getRecentJobs = () => client.get("/jobs/recent");

// Admin only (enforced server-side).
export const createJob = (payload) => client.post("/jobs/createjob", payload);

export const updateJob = (id, payload) => client.put(`/jobs/update/${id}`, payload);

export const deleteJob = (id) => client.delete(`/jobs/delete/${id}`);
